import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { priceFormat } from '../../../../util';
import { IncrementDecrement, IncrementDecrementInner } from '../../../controls/NumberPillInput/NumberPillInput.styles';
import { OrderListItem, OrderListItemName } from './ReplacementOrderItem.styles';

const ShopifyOrderItemModel = PropTypes.shape({
  id: PropTypes.number.isRequired,
  variant_id: PropTypes.number.isRequired,
  product_id: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  grams: PropTypes.number.isRequired,
  fulfillable_quantity: PropTypes.number.isRequired,
  taxable: PropTypes.bool.isRequired,
  product_exists: PropTypes.bool.isRequired,
  requires_shipping: PropTypes.bool.isRequired,
  vendor: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  total_discount: PropTypes.string.isRequired,
  properties: PropTypes.array.isRequired,
  tax_lines: PropTypes.array.isRequired,
  discount_allocations: PropTypes.array.isRequired,
  variant_title: PropTypes.any,
  variant_inventory_management: PropTypes.any,
  fulfillment_status: PropTypes.any,
}).isRequired;

class ReplacementOrderItem extends Component {
  static propTypes = {
    order: PropTypes.object.isRequired,
    orderItem: ShopifyOrderItemModel,
    quantity: PropTypes.number,
    onQuantityChanged: PropTypes.func,
  };

  static defaultProps = {
    quantity: 0,
    onQuantityChanged: () => {},
  };

  step = 1;

  get availableToReplaceQty() {
    return this.props.orderItem.quantity - this.getRefundQuantity();
  }

  componentDidMount() {
    this.props.onQuantityChanged(this.availableToReplaceQty);
  }

  getRefundQuantity() {
    return (this.props.order.refunds || [])
      .map(({ refund_line_items }) => refund_line_items)
      .filter((items) => Array.isArray(items))
      .reduce((count, items) => {
        items.forEach(({ line_item_id: id, quantity }) => {
          if (this.props.orderItem.id === id) {
            count += quantity;
          }
        });

        return count;
      }, 0);
  }

  decrement = () => {
    const replaceQuantity = this.props.quantity - this.step;
    if (replaceQuantity >= 0) {
      this.props.onQuantityChanged(replaceQuantity);
    }
  };

  increment = () => {
    const replaceQuantity = this.props.quantity + this.step;
    if (replaceQuantity <= this.availableToReplaceQty) {
      this.props.onQuantityChanged(replaceQuantity);
    }
  };

  render() {
    return (
      <OrderListItem>
        <OrderListItemName through={!this.props.quantity}>
          <div>
            ( {this.availableToReplaceQty} ) {this.props.orderItem.name} (
            {priceFormat(this.props.orderItem.price, this.props.order.currency)})
          </div>
          <div>{this.props.orderItem.sku}</div>
        </OrderListItemName>
        <IncrementDecrement>
          <IncrementDecrementInner>
            <label className="padding-horizontal float-left cursor item" onClick={this.decrement}>
              -
            </label>
            <label className="padding-horizontal quantity">{this.props.quantity}</label>
            <label className="padding-horizontal float-right cursor item" onClick={this.increment}>
              +
            </label>
          </IncrementDecrementInner>
        </IncrementDecrement>
      </OrderListItem>
    );
  }
}

export default ReplacementOrderItem;
